import { request } from '../utils/request'
import { NextPageContext } from 'next'
import { apiURL } from '../utils/url'
import { apiRoutes } from '../routes'
import { SpecialSpot } from './specialSpot'

export interface Menu {
  readonly id: string
  readonly menu_ja: string
  readonly menu_en: string
  readonly detail_ja: string
  readonly detail_en: string
  readonly time: string
  readonly price: string
  readonly special_spot: SpecialSpot
}

export async function createMenu(
  stylistId: string,
  menu_ja: string,
  menu_en: string,
  detail_ja: string,
  detail_en: string,
  time: string,
  price: string,
  special_spot_id: number | null,
) {
  const response = await request(apiURL(apiRoutes.menu), {
    method: 'POST',
    body: JSON.stringify({
      stylist_id: stylistId,
      menu_ja: menu_ja,
      menu_en: menu_en,
      detail_ja: detail_ja,
      detail_en: detail_en,
      time: time,
      price: price,
      special_spot_id: special_spot_id,
    }),
  })

  return [response.ok, response.status]
}

export async function updateMenu(
  menuId: string,
  menu_ja: string,
  menu_en: string,
  detail_ja: string,
  detail_en: string,
  time: string,
  price: string,
  special_spot_id: number | null,
) {
  const response = await request(apiURL(apiRoutes.menuId, menuId), {
    method: 'PATCH',
    body: JSON.stringify({
      menu_ja: menu_ja,
      menu_en: menu_en,
      detail_ja: detail_ja,
      detail_en: detail_en,
      time: time,
      price: price,
      special_spot_id: special_spot_id,
    }),
  })

  if (!response.ok) {
    throw new Error('Failed to update menu')
  }
}

export async function deleteMenu(menuId: string) {
  const response = await request(apiURL(apiRoutes.menuId, menuId), {
    method: 'DELETE',
  })

  if (!response.ok) {
    throw new Error('Failed to delete menu')
  }
}

export async function fetchMenus(stylistId: string, req?: NextPageContext['req']) {
  const reqURL = apiURL(apiRoutes.menu)
  reqURL.searchParams.append('stylist_id', stylistId)

  const response = await request(reqURL, {}, req)

  if (!response.ok) {
    throw new Error('Failed to fetch menus')
  }

  const json = await response.json()
  return menusFromJSONList(json)
}

function menusFromJSONList(jsonList: any): Menu[] {
  var result: Menu[] = []

  jsonList.menus.forEach((json: any) => {
    result.push(menuFromJSON(json))
  })

  return result
}

export function menuFromJSON(json: any): Menu {
  return {
    id: json.id,
    menu_ja: json.menu_ja,
    menu_en: json.menu_en,
    detail_ja: json.detail_ja,
    detail_en: json.detail_en,
    time: json.time,
    price: json.price,
    special_spot: json.special_spot,
  }
}
